export default {"src":"/_next/static/media/stripe.b5c1b8ed.svg","height":151,"width":360,"blurWidth":0,"blurHeight":0};